<template>
    <div class="row">
        <Loading v-if="showLoading" />
        <div :class="order.orderTypeId == 143 && $store.state.role != 'admin' ? 'col-md-12' : 'col-md-9'">
            <div class="card mb-3">
                <div class="card-header p-3 tx-medium my-auto tx-white bg-gray-800">اطلاعات سفارش</div>
                <div class="card-body">
                    <div class="timeline-steps aos-init aos-animate mb-2" v-if="false">
                        <div v-for="(step,index) in flows" :key="index" :class="order.sort == step.sort ? 'timeline-step mb-0 current' : (order.sort > step.sort ? 'timeline-step active' : 'timeline-step mb-0')">
                            <div class="timeline-content" data-toggle="popover" data-trigger="hover" data-placement="top">
                                <div class="inner-circle"></div>
                                <p class="h6 text-muted mt-2 mb-0 mb-lg-0">{{ step.sort > order.sort ? step.title : (step.subFlows[order.flowStepStatusId] || step.title) }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="table-responsive">
                        <table class="table table-bordered table-hover mb-0 order-table-details" v-if="order.domainMetadata && Object.keys(order.domainMetadata).length">
                            <tbody>
                                <tr>
                                    <td>شماره سفارش:</td>
                                    <td>{{ order.orderId }}</td>
                                    <td>وضعیت سفارش:</td>
                                    <td>{{ order.statusTitle }}</td>
                                    <td>نوع سفارش:</td>
                                    <td>فروش کارت هدیه شعب</td>
                                </tr>
                                <tr>
                                    <td>کاربر تایید کننده مالی:</td>
                                    <td>{{ order.financeVerify ? order.financeVerifier : '-' }}</td>
                                    <td>تاریخ سفارش:</td>
                                    <td>{{ order.createdAtPersian }}</td>
                                    <td>نام مشتری:</td>
                                    <td>{{ order.domainMetadata.firstName + ' ' + order.domainMetadata.lastName }}</td>
                                </tr>
                                <tr>
                                    <td>شعبه سفارش دهنده:</td>
                                    <td>{{ order.branchName + ' - ' + order.branchCode }}</td>
                                    <td>آدرس شعبه:</td>
                                    <td colspan="3">{{ order.branchProvince }}. {{ order.branchCity }} {{ order.branchAddress }}</td>
                                </tr>
                                <tr>
                                    <td>کد پستی:</td>
                                    <td>{{ order.branchZipCode }}</td>
                                    <td>شماره تماس:</td>
                                    <td dir="ltr">{{ order.branchPhoneAreaCode }}-{{ order.branchPhone1 }}</td>
                                    <td>شماره تماس:</td>
                                    <td dir="ltr">{{ order.branchPhoneAreaCode }}-{{ order.branchPhone2 }}</td>
                                </tr>
                                <tr v-if="order.description" style="border-left: 1px solid #262644">
                                    <td>توضیحات عدم تایید/مرجوعی:</td>
                                    <td colspan="5">{{ order.description }}</td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="text-left mt-3" v-if="$store.state.role == 'admin' && order.branchAddress">
                            <button class="btn btn-secondary" @click="printLabel">چاپ لیبل آدرس</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="card mb-3">
                        <div class="card-header p-3 tx-medium my-auto tx-white bg-gray-800">کارت های این سفارش</div>
                        <div class="card-body">
                            <button class="btn btn-success btn-rounded mb-4 ml-2" v-if="order.flowStepStatusId == 4 && !$store.state.userData.isOrganization && !$store.state.userData.isPishkhan" @click="approveOrRejectAll(true)">تایید سفارش</button>
                            <button class="btn btn-danger btn-rounded mb-4" data-toggle="modal" data-target="#reject-order" v-if="order.flowStepStatusId == 4 && !$store.state.userData.isOrganization && !$store.state.userData.isPishkhan">عدم تایید سفارش</button>
                            <div class="card bg-gray-100 mb-3" v-for="(orderItem,index) in order.orderItems" :key="index">
                                <div class="col-md-12">
                                    <div class="row">
                                        <div class="col-md-3">
                                            <img :src="orderItem.theme ? 'https://cardapi.sabinarya.com' + orderItem.theme.address : orderItem.imageUrl" :alt="orderItem.theme ? orderItem.theme.title : ''" class="my-3 rounded-10">
                                        </div>
                                        <div class="col-md-9 pr-0 mt-3">
                                            <h5 class="theme-title mb-3"><b>{{ orderItem.theme ? orderItem.theme.title : 'کارت هدیه با طرح دلخواه' }}</b></h5>
                                            <h5 class="theme-title mb-3" v-if="orderItem.count">تعداد : <b>{{ orderItem.count }}</b></h5>
                                            <h5 class="theme-title mb-3">وضعیت : 
                                                <span v-if="orderItem.status == 1"><b>در انتظار بررسی</b></span>
                                                <span v-else-if="orderItem.status == 2"><b>تایید شده</b></span>
                                                <span v-else-if="orderItem.status == 3"><b>عدم تایید</b></span>
                                                <span v-else-if="orderItem.status == 4"><b>پرداخت نشده</b></span>
                                                <span v-else><b>شارژ شده</b></span>
                                            </h5>
                                            <h5 class="theme-title mb-3 text-danger">نمایش مبلغ روی کارت : <b>{{ orderItem.showAmount ? 'بله' : 'خیر' }}</b></h5>
                                            <h5 class="theme-title mb-3" v-if="orderItemDescription">نظر روابط عمومی : <b>{{ orderItemDescription }}</b></h5>
                                            <div class="header-button-box">
                                                <button class="btn btn-primary btn-rounded" v-if="!orderItem.themeId" @click="downloadImage(orderItem.imageUrl)" target="_blank">مشاهده تصویر کارت</button>
                                                <button class="btn btn-warning mr-2 btn-rounded" v-if="!orderItem.themeId" @click="downloadImageDirectly(orderItem.orderItemId)" target="_blank">دانلود تصویر کارت</button>
                                            </div>
                                            <div class="footer-button-box">
                                                <button class="btn btn-info btn-rounded" v-if="order.flowStepStatusId == 183 && $store.state.role == 'bankpublicrelations'" @click="enableEditCardItem(orderItem.orderItemId)">ویرایش طرح کارت</button>
                                            </div>
                                            <div class="footer-button-box" v-if="orderItem.cardId && order.orderTypeId != 2 && ($store.state.adminTokenExpireTime || new Date().getTime() > $store.state.adminTokenExpireTime) && !$store.state.userData.isOrganization">
                                                <button class="btn btn-success btn-rounded ml-2" data-toggle="modal" data-target="#cards-pans" v-if="false/* && orderItem.cardId && order.orderTypeId != 2 && (!$store.state.adminTokenExpireTime || new Date().getTime() > $store.state.adminTokenExpireTime)*/" @click="getCardsDetails(orderItem.key)">دریافت اطلاعات کارت ها</button>
                                                <button class="btn btn-success btn-rounded ml-2" v-if="orderItem.cardId && order.orderTypeId != 2 && /*$store.state.role != 'bankpublicrelations' && $store.state.role != 'finance'*/ $store.state.role == 'admin' && orderItem.getTrack" @click="getCardsDetails(orderItem.key)">دریافت اطلاعات کارت ها</button>
                                                <button class="btn btn-secondary btn-rounded" v-if="($store.state.role == 'branches' || $store.state.role == 'izbank-admin') && false" @click="printCard(orderItem)">چاپ کارت</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="modal effect-scale" id="cards-pans" aria-hidden="true">
                                    <div class="modal-dialog modal-dialog-centered" role="document">
                                        <div class="modal-content modal-content-demo">
                                            <div class="modal-header">
                                                <h6 class="modal-title">اطلاعات کارت ها</h6>
                                                <button aria-label="بستن" class="close" data-dismiss="modal" type="button"><span aria-hidden="true">×</span></button>
                                            </div>
                                            <div class="modal-body">
                                                <div class="alert alert-info">
                                                    <p>کد اعتبارسنجی به شماره همراه شما ارسال شد</p>
                                                </div>
                                                <div class="form-group">
                                                    <label>کد اعتبارسنجی</label>
                                                    <input type="tel" class="form-control text-center" v-mask="'#####'" v-model="token">
                                                </div>
                                                <button class="btn btn-success" @click="setToken">ثبت و تایید</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card mb-3" v-if="enableEditCard">
                        <div class="card-header p-3 tx-medium my-auto tx-white bg-gray-800">ویرایش طرح کارت</div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-8">
                                    <div class="row create-cart-box justify-content-center text-center" v-if="imageSrc">
                                        <p class="w-100">تصویر مورد نظر خود را انتخاب کنید</p>
                                        <div class="col-md-8 text-center">
                                            <img id="image" :src="imageSrc">
                                        </div>
                                    </div>
                                    <div class="row justify-content-center text-center" v-else>
                                        <p class="w-100 mb-4">تصویر مورد نظر خود را انتخاب کنید</p>
                                        <div class="col-12 mb-4">
                                            <div class="row">
                                                <div class="col-md-3 text-right">
                                                    <label class="rdiobox"><input name="rdio" type="radio" value="all" v-model="imagesType" checked> <span>همه تصاویر</span></label>
                                                </div>
                                                <div class="col-md-3 text-right">
                                                    <label class="rdiobox"><input name="rdio" type="radio" value="system" v-model="imagesType"> <span>تصاویر پیشفرض</span></label>
                                                </div>
                                                <div class="col-md-3 text-right">
                                                    <label class="rdiobox"><input name="rdio" type="radio" value="user" v-model="imagesType"> <span>تصاویر آپلود شده</span></label>
                                                </div>
                                                <div class="col-md-3 text-right">
                                                    <label class="rdiobox"><input name="rdio" type="radio" value="new" v-model="imagesType"> <span>آپلود تصویر جدید</span></label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-12" v-if="imagesType != 'new'">
                                            <div class="row" v-if="images.length || mainImageData">
                                                <div class="col-md-4 mb-3">
                                                    <img class="organization-image" @click="setImageFile(mainImageData)" :src="mainImageData" alt="">
                                                </div>
                                                <div class="col-md-4 mb-3" v-for="(image,index) in images" :key="index">
                                                    <img class="organization-image" @click="setImageId(image.mediaId)" :src="`https://cardapi.sabinarya.com/${image.picUrl}`" alt="">
                                                </div>
                                            </div>
                                            <div class="row" v-else>
                                                <div class="col-md-12">
                                                    <div class="alert alert-info">
                                                        <p class="mb-0">تصویری یافت نشد</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-12" v-else>
                                            <div :style="{display: currentStep == 1 ? 'unset' : 'none'}">
                                                <div class="row create-cart-box justify-content-center" v-if="imageSrc">
                                                    <div class="col-md-8 text-center">
                                                        <img id="image" :src="imageSrc">
                                                        <button class="btn btn-custom ml-1 mt-4 btn-dark" @click="changeImage">تغییر تصویر</button>
                                                        <button class="btn btn-primary btn-custom mt-4" @click="currentStep++">مرحله بعد</button>
                                                    </div>
                                                </div>
                                                <div class="row justify-content-center text-center" v-else>
                                                    <p class="w-100 mb-2">تصویر مورد نظر خود را انتخاب کنید</p>
                                                    <div class="mt-3 mb-2">
                                                        <label for="custom-file-upload" class="filupp">
                                                            <span class="filupp-file-name js-value">انتخاب تصویر</span>
                                                            <input type="file" name="attachment-file" value="1" id="custom-file-upload" @change="setImage" accept="image/png,image/jpeg">
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <h6 class="custom-card-box-title">پیش نمایش</h6>
                                    <hr class="mb-4">
                                    <div id="preview-parent">
                                        <div id="preview-container" class="mt-3">
                                            <img src="/assets/img/giftcard.png" class="card-template">
                                            <div id="preview"></div>
                                        </div>
                                    </div>
                                    <div class="form-group" v-if="imageSrc && madeImage">
                                        <label>علت ویرایش طرح</label>
                                        <input type="text" class="form-control" v-model="comment">
                                    </div>
                                    <button v-if="imageSrc && !madeImage" :class="(!imageUrl ? 'btn btn-custom ml-1 btn-dark mt-1' : 'btn btn-custom ml-1 btn-dark mt-1')" @click="changeImage">تغییر تصویر</button>
                                    <button v-if="imageSrc && !madeImage" :class="(!imageUrl ? 'btn btn-success ml-1 btn-custom mt-1' : 'btn btn-success ml-1 btn-custom mt-1')" @click="makeImage" :disabled="editBtn">تایید طرح</button>
                                    <button v-if="imageSrc && madeImage" :class="(!imageUrl ? 'btn btn-success ml-1 btn-custom mt-1' : 'btn btn-success ml-1 btn-custom mt-1')" @click="updateOrderItem(orderItemId,cardMetadataId)">ثبت تغییرات</button>
                                    <button class="btn btn-danger mt-1" @click="disableEditCard">لغو تغییرات</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card mb-3" v-if="transactions.length">
                        <Loading v-if="showLoading" />
                        <div class="card-header p-3 tx-medium my-auto tx-white bg-gray-800">لیست پرداخت ها</div>
                        <div class="card-body">
                            <table class="table table-bordered table-hover mb-0">
                                <thead>
                                    <tr>
                                        <th>مبلغ</th>
                                        <th>شماره مرجع</th>
                                        <th>شماره پیگیری</th>
                                        <th>وضعیت</th>
                                        <th>تاریخ</th>
                                        <th>تصویر رسید</th>
                                        <th>عملیات</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(transaction,index) in transactions" :key="index">
                                        <th>{{ new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(transaction.amount) + ' ریال' }}</th>
                                        <th>{{ transaction.trRrn || '-' }}</th>
                                        <th>{{ transaction.trPaymentid || '-' }}</th>
                                        <th><span class="badge badge-success">موفق</span></th>
                                        <th>{{ new Date(transaction.createdAt).toLocaleTimeString('fa-ir') + ' - ' + new Date(transaction.createdAt).toLocaleDateString('fa-ir') }}</th>
                                        <th v-if="transaction.receiptId"><a @click="openReceipts(transaction.transactionId)" target="_blank" style="cursor: pointer">کلیک کنید</a></th>
                                        <th v-else>-</th>
                                        <th class="btn-icon-list" v-if="transaction.transactionStatusId == 41 && $store.state.role == 'finance'">
                                            <button class="btn btn-success btn-icon" @click="changeTransactionStatus(true,transaction.transactionId)"><i class="fa fa-check"></i></button>
                                            <button class="btn btn-danger btn-icon" @click="changeTransactionStatus(false,transaction.transactionId)"><i class="fa fa-times"></i></button>
                                        </th>
                                        <th v-else>
                                            -
                                        </th>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-3">
            <div class="card mb-3" v-if="order.orderTypeId == 143 && $store.state.role == 'admin'">
                <Loading v-if="showLoading" />
                <div class="card-header p-3 tx-medium my-auto tx-white bg-gray-800">عملیات و جزئیات</div>
                <div class="card-body">
                    <p v-if="order.additionalData1">{{ order.additionalData1.split(':')[0] }}: <span dir="ltr">{{ order.additionalData1.split(':')[1] }}</span></p>
                    <p v-if="order.additionalData2">{{ order.additionalData2 }}</p>
                    <button class="btn btn-success btn-block" data-target="#reissue" data-toggle="modal" v-if="order.flowStepStatusId == 245">ثبت اطلاعات کارت جدید</button>
                </div>
            </div>
            <a class="btn btn-warning mb-3 btn-block py-3" v-if="order.trackingCode && order.flowStepStatusId == 8" href="https://tracking.post.ir" target="_blank">پیگیری مرسوله</a>
            <div class="alert alert-warning" v-if="order.trackingCode">
                <p class="mb-0">{{ order.trackingCode }}</p>
            </div>
            <div class="card mb-3" v-if="($store.state.role == 'bankpublicrelations' && (order.flowStepStatusId == 183) || (order.flowStepStatusId == 184)) || ($store.state.role == 'finance' && order.flowStepStatusId == 21 && !order.financeVerify) || ($store.state.role == 'admin' && (order.flowStepStatusId == 31 || order.flowStepStatusId == 32)) || (($store.state.role == 'branches' || $store.state.role == 'izbank-admin') && (order.flowStepStatusId == 8 || order.flowStepStatusId == 142)) || (($store.state.role == 'branches' || $store.state.role == 'izbank-admin') && order.flowStepStatusId == 8) || (order.flowStepId == 43 && order.flowStepStatusId == 8 && false)">
                <Loading v-if="showLoading" />
                <div class="card-header p-3 tx-medium my-auto tx-white bg-gray-800">عملیات</div>
                <div class="card-body">
                    <button class="btn btn-success btn-block" @click="publicRelationsApprove(1)" v-if="order.flowStepStatusId == 183">تایید روابط عمومی</button>
                    <button class="btn btn-danger btn-block" data-effect="effect-scale" data-toggle="modal" href="#reject" v-if="order.flowStepStatusId == 183">عدم تایید روابط عمومی</button>
                    <button class="btn btn-success btn-block" @click="customerApprove(1)" v-if="order.flowStepStatusId == 184 && ($store.state.role == 'branches' || $store.state.role == 'izbank-admin')">تایید طرح توسط مشتری</button>
                    <button class="btn btn-danger btn-block" @click="customerApprove(0)" v-if="order.flowStepStatusId == 184 && ($store.state.role == 'branches' || $store.state.role == 'izbank-admin')">عدم تایید طرح توسط مشتری</button>
                    <button class="btn btn-success btn-block" @click="financialApprove" v-if="$store.state.role == 'finance' && order.flowStepStatusId == 21 && !order.financeVerify">تاییدیه مالی</button>
                    <button class="btn btn-danger btn-block" data-target="#finance-reject" data-toggle="modal" v-if="$store.state.role == 'finance' && order.flowStepStatusId == 21 && !order.financeVerify">عدم تایید مالی</button>
                    <button class="btn btn-primary btn-block" @click="sent" v-if="$store.state.role == 'admin' && (order.flowStepStatusId == 31 || order.flowStepStatusId == 32)">ارسال شده</button>
                    <button class="btn btn-info btn-block" @click="delivered" v-if="order.flowStepStatusId != 32 && order.flowStepStatusId != 21 && order.flowStepStatusId != 28 &&  ($store.state.role == 'branches' || $store.state.role == 'izbank-admin') && (order.flowStepStatusId == 8 || order.flowStepStatusId == 142 )">تحویل شده</button>
                    <button class="btn btn-danger btn-block" @click="notDelivered" v-if="order.flowStepStatusId != 32 && order.flowStepStatusId != 21 && order.flowStepStatusId != 28 && ($store.state.role == 'branches' || $store.state.role == 'izbank-admin') && order.flowStepStatusId == 8">تحویل نشده</button>
                    <button class="btn btn-warning btn-block" data-effect="effect-scale" data-toggle="modal" href="#refound" v-if="order.flowStepStatusId != 32 && order.flowStepStatusId != 21 && order.flowStepStatusId != 28 &&  order.flowStepId == 43 && order.flowStepStatusId == 8 && false">ثبت مرجوعی سفارش</button>
                </div>
            </div>
            <div class="card" v-if="order.lastPayment">
                <div class="card-header p-3 tx-medium my-auto tx-white bg-gray-800">اطلاعات پرداخت</div>
                <div class="card-body">
                    وضعیت پرداخت : <span v-if="order.lastPayment.paymentStatusId == 22" class="text-success">پرداخت شده</span><span v-else class="text-danger">پرداخت نشده</span>
                </div>
            </div>
        </div>
        <div class="modal effect-scale" id="reject" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content modal-content-demo">
                    <div class="modal-header">
                        <h6 class="modal-title">علت عدم تایید</h6>
                        <button aria-label="بستن" class="close" data-dismiss="modal" type="button"><span aria-hidden="true">×</span></button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label>توضیحات</label>
                                    <textarea rows="4" class="form-control" v-model="description"></textarea>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <button class="btn btn-success" @click="publicRelationsApprove(2)" data-dismiss="modal">ثبت عدم تایید</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal effect-scale" id="finance-reject" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content modal-content-demo">
                    <div class="modal-header">
                        <h6 class="modal-title">علت عدم تایید</h6>
                        <button aria-label="بستن" class="close" data-dismiss="modal" type="button"><span aria-hidden="true">×</span></button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label>توضیحات</label>
                                    <textarea rows="4" class="form-control" v-model="financeRejectDescription"></textarea>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <button class="btn btn-success" @click="financialReject" data-dismiss="modal">ثبت عدم تایید</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal effect-scale" id="reissue" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content modal-content-demo">
                    <div class="modal-header">
                        <h6 class="modal-title">اطلاعات کارت جدید</h6>
                        <button aria-label="بستن" class="close" data-dismiss="modal" type="button"><span aria-hidden="true">×</span></button>
                    </div>
                    <div class="modal-body">
                        <Loading v-if="showModalLoading" />
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label>شماره کارت</label>
                                    <input type="tel" v-mask="'####-####-####-####'" class="form-control" v-model="rePan">
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="form-group">
                                    <label>ماه انقضا</label>
                                    <input type="tel" v-mask="'##'" class="form-control" v-model="reMonth">
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="form-group">
                                    <label>سال انقضا</label>
                                    <input type="tel" v-mask="'##'" class="form-control" v-model="reYear">
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="form-group">
                                    <label>CVV2</label>
                                    <input type="tel" v-mask="'####'" class="form-control" v-model="reCvv2">
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label>نوع کارت</label>
                                    <Vselect v-model="reCType" :reduce="item => item.cardTypeId" label="title" :options="cardTypes">
                                        <div slot="no-options">مقداری یافت نشد</div>
                                    </Vselect>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label>صادر کننده</label>
                                    <Vselect v-model="reIssuer" :reduce="item => item.id" label="title" :options="providers">
                                        <div slot="no-options">مقداری یافت نشد</div>
                                    </Vselect>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <button class="btn btn-success" @click="reissue" data-dismiss="modal">ثبت اطلاعات کارت</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal effect-scale" id="refound" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <form class="modal-content modal-content-demo">
                    <div class="modal-header">
                        <h6 class="modal-title">ثبت مرجوعی سفارش</h6>
                        <button aria-label="بستن" class="close" data-dismiss="modal" type="button"><span aria-hidden="true">×</span></button>
                    </div>
                    <div class="modal-body">
                        <div class="form-group">
                            <label for="reason">علت</label>
                            <select id="reason" class="form-control" v-model="returnId">
                                <option :value="returnTitle.returnId" v-for="(returnTitle,index) in returns" :key="index">{{ returnTitle.description }}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label for="description">توضیحات</label>
                            <textarea id="description" class="form-control" rows="3" v-model="returnDescription"></textarea>
                        </div>
                        <button class="btn btn-success" type="button" @click="returnOrder" data-dismiss="modal">ثبت مرجوعی</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import Cropper from 'cropperjs';
import html2canvas from 'html2canvas';
export default {
    name: 'Single',
    data(){
        return {
            showLoading: true,
            showModalLoading: false,
            paymentIdentifier: '',
            rrn: '',
            amount: 0,
            file: '',
            discount: null,
            deposit: 0,
            description: '',
            returns: [],
            flows: [],
            returnId: 0,
            token: '',
            returnDescription: '',
            enableEditCard: false,
            allImages: [],
            images: [],
            cardTypes: [],
            providers: [],
            rePan: '505785',
            reMonth: '',
            reYear: '',
            reCvv2: '',
            reCType: '',
            reIssuer: '',
            imagesType: 'all',
            currentStep: 1,
            orderItemId: 0,
            cardMetadataId: 0,
            imageSrc: '',
            imageUrl: '',
            comment: '',
            mainImageData: '',
            orderItemDescription: '',
            financeRejectDescription:'',
            transactions: [],
            editBtn: false,
            madeImage: false,
            order: {}
        }
    },
    methods: {
        getBaseData(){
            this.$api.get('Cards/Types').then(({data}) => {
                this.cardTypes = data.result;
            });
            this.$api.get('Organizations/Issuers').then(({data}) => {
                if(data.status)
                    this.providers = data.result;
            })
        },
        reissue(){
            this.showModalLoading = true;
            const postedData = {
                pan: this.rePan.replace(/-/g,''),
                expMonth: this.reMonth,
                expYear: this.reYear,
                cvv2: this.reCvv2,
                orderId: this.$route.params.id,
                cardTypeId: this.reCType,
                issuerId: this.reIssuer
            };
            this.$api.post('Orders/RegenrateSubmit',postedData).then(({data}) => {
                if(data.status)
                    this.$swal({
                        icon: 'success',
                        title: 'تبریک',
                        text: 'عملیات با موفقیت انجام شد',
                        confirmButtonText: 'متوجه شدم'
                    }).then(() => {
                        this.getData();
                    });
            }).finally(() => {
                this.showModalLoading = false;
            })
        },
        enableEditCardItem(orderItemId){
            this.orderItemId = orderItemId;
            this.enableEditCard = true;
        },
        disableEditCard(){
            this.enableEditCard = false
            this.imageSrc = '';
            this.imageUrl = '';
            document.getElementsByClassName('cropper-container')[0].remove();
            document.getElementById('preview').childNodes[0].remove();
        },
        setImageFile(data){
            this.imageSrc = data;
            this.mainImageData = data;
            setTimeout(() => {
                const image = document.getElementById('image');
                new Cropper(image,{
                    aspectRatio: 91.00 / 58.00,
                    viewMode: 1,
                    preview: '#preview',
                    autoCropArea: 0.8,
                    dragMode: 'move'
                });
            },100);
        },
        customerApprove(state){
            this.showLoading = true;
            const postedData = {
                orderId: this.$route.params.id,
                flowStatusId: state == 1 ? 307 : 291
            };
            this.$api.post('Branches/Order/ChangeStatus',postedData).then(({data}) => {
                if(data.status)
                    this.$swal({
                        icon: 'success',
                        title: 'تبریک',
                        text: 'عملیات با موفقیت انجام شد',
                        confirmButtonText: 'متوجه شدم'
                    }).then(() => {
                        this.getData();
                    });
            }).finally(() => {
                this.showLoading = false;
            });
        },
        setImage(e){
            let reader = new FileReader();
            reader.onload = e => {
                this.imageSrc = e.target.result;
                this.mainImageData = e.target.result;
            }
            reader.readAsDataURL(e.target.files[0]);
            setTimeout(() => {
                const image = document.getElementById('image');
                new Cropper(image,{
                    aspectRatio: 91.00 / 58.00,
                    viewMode: 1,
                    preview: '#preview',
                    autoCropArea: 0.8,
                    dragMode: 'move'
                });
            },100);
        },
        async setImageId(id){
            const result = await this.$api.get('Organizations/Media/' + id);
            this.imageSrc = 'data:image/jpeg;base64,' + result.data.base64;
            this.mainImageData = 'data:image/jpeg;base64,' +  result.data.base64;
            setTimeout(() => {
                const image = document.getElementById('image');
                new Cropper(image,{
                    aspectRatio: 91.00 / 58.00,
                    viewMode: 1,
                    preview: '#preview',
                    autoCropArea: 0.8,
                    dragMode: 'move'
                });
            },100);
        },
        makeImage(){
            this.editBtn = false;
            document.getElementById('preview-container').style.transform = 'unset';
            html2canvas(document.getElementById('preview-container')).then(canvas => {
                this.imageUrl = canvas.toDataURL('image/png');
            });
            document.getElementById('preview-container').style.transform = 'scale(0.32)';
            this.editBtn = true;
            this.madeImage = true;
        },
        updateOrderItem(orderItemId,oldMetaDataId){
            this.showLoading = true;
            this.enableEditCard = false;
            let metadatas = [
                {
                    key: 2,
                    base64: this.imageUrl
                },
                {
                    key: 81,
                    base64: this.mainImageData
                }
            ];
            const postedData = {
                orderId: this.$route.params.id,
                metadatas,
                orderItemId,
                comment: this.comment,
                oldCardMetaDataId: oldMetaDataId
            };
            this.$api.post('Branches/Item/Edit',postedData).then(({data}) => {
                if(data.status)
                    this.$swal({
                        icon: 'success',
                        title: 'تبریک',
                        text: 'تغییر طرح کارت با موفقیت انجام شد',
                        confirmButtonText: 'متوجه شدم'
                    }).then(() => {
                        this.imagesType = 'all';
                        this.currentStep = 1;
                        this.imageSrc = '';
                        this.imageUrl = '';
                        this.comment = '';
                        this.editBtn = false;
                        this.madeImage = false;
                        this.getData();
                    });
            }).finally(() => {
                this.showLoading = false;
            });
        },
        setToken(){
            this.$api.post('Management/Card/VerifyToken',{otpCode: this.token.toString()}).then(({data}) => {
                if(data.result){
                    this.$store.state.adminToken = this.token;
                    this.$store.state.adminTokenExpireTime = new Date().getTime() + (5 * 60 * 1000);
                    this.$swal({
                        title: 'تبریک',
                        icon: 'success',
                        text: 'کد اعتبارسنجی با موفقیت ثبت شد'
                    });
                    $('#cards-pans').modal('toggle');
                }else
                    this.$swal({
                        title: 'خطا',
                        icon: 'error',
                        text: 'کد وارد شده اشتباه است'
                    });
            }).finally(() => {
                this.showLoading = false;
            });
        },
        publicRelationsApprove(status){
            this.showLoading = true;
            if(status == 1){
                this.$api.post('Branches/Order/Approve',{orderId: this.$route.params.id}).then(({data}) => {
                    if(data.status)
                        this.$swal({
                            icon: 'success',
                            title: 'تبریک',
                            text: 'تایید کارت با موفقیت انجام شد',
                            confirmButtonText: 'متوجه شدم'
                        }).then(() => {
                            this.getData();
                        });
                }).finally(() => {
                    this.showLoading = false;
                });
            }else{
                this.$api.post('Branches/Order/Reject',{orderId: this.$route.params.id,comment: this.description}).then(({data}) => {
                    if(data.status)
                        this.$swal({
                            icon: 'success',
                            title: 'تبریک',
                            text: 'عدم تایید کارت با موفقیت انجام شد',
                            confirmButtonText: 'متوجه شدم'
                        }).then(() => {
                            this.getData();
                        });
                }).finally(() => {
                    this.showLoading = false;
                });
            }
            this.description = '';
        },
        openReceipts(id){
            window.open('https://cardapi.sabinarya.com/api/v1/Management/Receipts/' + id);
        },
        printLabel(){
            localStorage.setItem('branchOrderId',this.$route.params.id);
            setTimeout(() => {
                const routeData = this.$router.resolve({name: 'bankBranches.label'});
                window.open(routeData.href,'_blank');
            },500);
        },
        getCardsDetails(key){
            this.showLoading = true;
            // if(new Date().getTime() <= this.$store.state.adminTokenExpireTime){
            const postedData = {
                orderId: parseInt(this.$route.params.id),
                key
            };
            this.$api.post('Management/Card/Sheet',postedData).then(({data}) => {
                let a = window.document.createElement('a');
                a.setAttribute('href','https://cardapi.sabinarya.com/api/v1/Lookup/download/' + data.result.fileString);
                let fileName = data.result.fileString;
                a.setAttribute('download',fileName);
                window.document.body.appendChild(a);
                a.click();
                window.document.body.removeChild(a);
            }).finally(() => {
                this.showLoading = false;
            });
            // }else
            //     this.$api.post('Management/Card/GenerateToken').then(({data}) => {
            //         if(data.status)
            //             this.$store.state.adminTokenExpireTime = new Date().getTime() + (5 * 60 * 1000);
            //     });
        },
        async getData(){
            this.showLoading = true;
            this.getTransactions();
            this.$api.get('Management/Returns').then(({data}) => {
                this.returns = data.result;
            });
            this.$api.get('Organizations/Media?Option=2').then(({data}) => {
                if(data.status && data.result.length){
                    this.images = data.result.filter(image => image.metadataKeyId == 2 && image.isApproved);
                    this.allImages = data.result.filter(image => image.metadataKeyId == 2 && image.isApproved);
                    let texts = [];
                    data.result.map(text => {
                        if(text.metadataKeyId == 3 && text.isApproved)
                            texts.push({
                                ...text,
                                value: text.text
                            });
                    });
                    this.texts = texts;
                }
            });
            if(this.$store.state.userData.isOrganization){
                this.$api.get('Organizations/Wallet/Balance').then(({data}) => {
                    if(data.status)
                        this.deposit = new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(data.result);
                });
            }
            this.$api.get('Orders/' + this.$route.params.id).then(({data}) => {
                let orderItems = [];
                data.result.orderItems.map(item => {
                    if(!item.themeId){
                        let orderItemImage = item.cardMetadata.filter(meta => meta.metadataKeyId == 2)[0];
                        let orderItemMainImage = item.cardMetadata.filter(meta => meta.metadataKeyId == 81)[0];
                        this.mainImageData = 'data:image/png;base64,' + (orderItemMainImage ? orderItemMainImage.value : '');
                        this.cardMetadataId = orderItemImage.cardMetadataId;
                        this.orderItemDescription = orderItemImage.description;
                        orderItems.push({
                            ...item,
                            imageUrl: 'data:image/png;base64,' + orderItemImage.value,
                        });
                    }else
                        orderItems.push({
                            ...item
                        });
                });
                this.order = data.result;
                this.order.orderItems = orderItems;
            }).finally(() => {
                this.showLoading = false;
            });
            await this.$api.get('Flows/' + 2).then(({data}) => {
                let flows = data.result;
                let finalFlows = [];
                let subFlows = {};
                flows.map(flow => {
                    subFlows = {};
                    flow.flowStepStatuses.map(flowStep => {
                        subFlows[flowStep.flowStepStatusId] = flowStep.title
                    });
                    finalFlows.push({
                        title: flow.title,
                        sort: flow.sort,
                        subFlows
                    });
                });
                this.flows = finalFlows;
            });
        },
        getTransactions(){
            this.$api.post('Management/Transactions',{orderId: parseInt(this.$route.params.id)}).then(({data}) => {
                if(data.transactions)
                    this.transactions = data.transactions;
            });
        },
        changeImage(){
            this.imageSrc = '';
            this.imageUrl = '';
            document.getElementsByClassName('cropper-container')[0].remove();
            document.getElementById('preview').childNodes[0].remove();
        },
        downloadImage(base64){
            let image = new Image();
            image.src = base64;
            let newWindow = window.open('');
            newWindow.document.write(image.outerHTML);
        },
        downloadImageDirectly(itemId){
            window.open('https://cardapi.sabinarya.com/api/v2/Metadata/Download?orderItemId=' + itemId);
        },
        financialReject(){
            this.showLoading = true;
            this.$api.post('Management/FinancialApprove',{orderId: parseInt(this.$route.params.id),confirm: false,description: this.financeRejectDescription}).then(({data}) => {
                this.showLoading = false;
                if(data.status){
                    this.$swal({
                        title: 'تبریک',
                        icon: 'success',
                        text: 'عدم تایید مالی سفارش با موفقیت انجام شد',
                        confirmButtonText: 'متوجه شدم'
                    });
                    this.getData();
                }
            }).finally(() => {
                this.showLoading = false;
            });
        },
        financialApprove(){
            this.showLoading = true;
            this.$api.post('Management/FinancialApprove',{orderId: parseInt(this.$route.params.id),confirm: true}).then(({data}) => {
                this.showLoading = false;
                if(data.status){
                    this.$swal({
                        title: 'تبریک',
                        icon: 'success',
                        text: 'تایید مالی درخواست با موفقیت انجام شد',
                        confirmButtonText: 'متوجه شدم'
                    });
                    this.getData();
                }
            }).finally(() => {
                this.showLoading = false;
            });
        },
        approveOrRejectAll(approve){
            this.$swal({
                title: 'هشدار',
                text: 'از انجام این کار اطمینان دارید ؟',
                icon: 'warning',
                confirmButtonText: 'تایید',
                showCancelButton: true,
                cancelButtonText: 'لغو'
            }).then(res => {
                if(res.isConfirmed){
                    this.showLoading = true;
                    const postedData = {
                        orderId: this.$route.params.id,
                        approve
                    };
                    if(this.discount)
                        postedData.discount = this.discount;
                    if(!approve)
                        postedData.description = this.description;
                    this.$api.post('Organizations/Bonus/Order/Approve',postedData).then(({data}) => {
                        if(data.status){
                            this.$swal({
                                title: 'تبریک',
                                icon: 'success',
                                text: 'سفارش با موفقیت ' + (!approve ? 'عدم تایید' : 'تایید') + ' شد',
                                confirmButtonText: 'متوجه شدم'
                            });
                            this.getData();
                        }

                    }).finally(() => {
                        this.showLoading = false;
                    });
                }
            });
        },
        numberFormat(){
            let value = this.amount.toString().replace(/,/g,'');
            value = new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(value);
            if(value == 'NaN')
                value = '';
            if(this.amount.toString().replace(/,/g,'') > this.order.totalAmount)
                this.amount = new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(this.order.totalAmount);
            else
                this.amount = value;
        },
        returnOrder(){
            this.showLoading = true;
            const postedData = {
                orderId: parseInt(this.$route.params.id),
                description: this.returnDescription,
                returnId: this.returnId
            };
            this.$api.post('Management/ReturnItems',postedData).then(({data}) => {
                if(data.status){
                    this.showLoading = false;
                    this.$swal({
                        title: 'تبریک',
                        icon: 'success',
                        text: 'ثبت مرجوعی با موفقیت انجام شد',
                        confirmButtonText: 'متوجه شدم'
                    });
                    this.getData();
                }
            }).finally(() => {
                this.showLoading = false;
            });
        },
        async toBase64(file){
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = error => reject(error);
            });
        },
        async setFile(e){
            const file = e.target.files[0];
            const finalFile = await this.toBase64(file);
            this.file = finalFile;
            document.getElementById('file-input').setAttribute('placeholder',file.name);
        },
        submitPayment(){
            this.showLoading = true;
            const postedData = {
                paymentIdentifier: this.paymentIdentifier,
                rrn: this.rrn,
                amount: parseInt(this.amount.toString().replace(/,/g,'')),
                orderId: parseInt(this.$route.params.id),
                base64Receipt: this.file
            };
            this.$api.post('Organizations/SubmitPayment',postedData).then(({data}) => {
                if(data.status){
                    this.paymentIdentifier = this.amount = this.rrn = this.pansFile = '';
                    document.getElementById('file-input').setAttribute('placeholder','');
                    this.getData();
                    this.$swal({
                        title: 'تبریک',
                        icon: 'success',
                        text: 'ثبت اطلاعات پرداخت با موفقیت انجام شد',
                        confirmButtonText: 'متوجه شدم'
                    });
                }
            }).catch(({response}) => {
                this.showLoading = false;
            });
        },
        payWithWallet(){
            this.showLoading = true;
            this.$api.post('Organizations/Bonus/Order/WalletPayment',{orderId: this.$route.params.id}).then(({data}) => {
                if(data.status){
                    this.getData();
                    this.$swal({
                        title: 'تبریک',
                        icon: 'success',
                        text: 'پرداخت با موفقیت انجام شد',
                        confirmButtonText: 'متوجه شدم'
                    });
                }
            }).finally(() => {
                this.showLoading = false;
            });
        },
        sent(){
            this.showLoading = true;
            const postedData = {
                orderId: parseInt(this.$route.params.id),
                flowStatusId: 347
            };
            this.$api.post('Branches/Order/ChangeStatus',postedData).then(({data}) => {
                if(data.status){
                    this.$swal({
                        title: 'تبریک',
                        icon: 'success',
                        text: 'وضعیت سفارش با موفقیت به روزرسانی شد',
                        confirmButtonText: 'متوجه شدم'
                    });
                    this.getData();
                }
            }).finally(() => {
                this.showLoading = false;
            });
        },
        chargeDeposit(){
            let amount = this.order.totalAmount - parseInt(this.deposit.toString().replace(/,/g,''));
            localStorage.setItem('amount',amount);
            this.$router.push({name: 'organization.wallet'});
        },
        delivered(){
            this.showLoading = true;
            const postedData = {
                orderId: this.$route.params.id,
                flowStatusId: 270
            };
            this.$api.post('Branches/Order/ChangeStatus',postedData).then(({data}) => {
                if(data.status){
                    this.$swal({
                        title: 'تبریک',
                        icon: 'success',
                        text: 'وضعیت سفارش با موفقیت به روزرسانی شد',
                        confirmButtonText: 'متوجه شدم'
                    }).then(() => {
                        this.getData();
                    });
                }
            }).finally(() => {
                this.showLoading = false;
            });
        },
        notDelivered(){
            this.showLoading = true;
            const postedData = {
                orderId: this.$route.params.id,
                flowStatusId: 388
            };
            this.$api.post('Branches/Order/ChangeStatus',postedData).then(({data}) => {
                if(data.status){
                    this.$swal({
                        title: 'تبریک',
                        icon: 'success',
                        text: 'وضعیت سفارش با موفقیت به روزرسانی شد',
                        confirmButtonText: 'متوجه شدم'
                    }).then(() => {
                        this.getData();
                    });
                }
            }).finally(() => {
                this.showLoading = false;
            });
        },
        printCard(orderItem){
            let cardId = orderItem.cardId;
            const postedData = {
                cardId: cardId,
                typeId: 58
            };
            this.$api.post('Print/AddCommand',postedData).then(({data}) => {
                if(data.status){
                    let gotData = data.result.command;
                    this.$api.post(gotData.agentLocalAddress,gotData).then(response => {
                        console.log(response);
                    });
                }
            });
        }
    },
    created(){
        this.getData();
        this.getBaseData();
    }
}
</script>